import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Keeps the welcome-code price in sync with the selected product variant.
 */
class OpFirstOrderOffer extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#section()?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section()?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #section() {
    return this.closest('.shopify-section, dialog');
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;

        const updatedOffer = detail.html.querySelector(
          `op-first-order-offer[data-block-id="${this.dataset.blockId}"]`
        );
        updatedOffer && this.replaceWith(updatedOffer);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[op-first-order-offer] Variant update failed:', error);
      });
  };
}

if (!customElements.get('op-first-order-offer')) {
  customElements.define('op-first-order-offer', OpFirstOrderOffer);
}
